import React from 'react';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';

const useStyles = theme => ({
    root: {
      flexGrow: 1,
    },
    politicaContenedor: {
        height: "100%",
        display: "flex",
        justifyContent: 'center',
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: "#fff",
        paddingBottom: "50px",
        
    },
    politicaText: {
        flexDirection: 'row',
        alignItems: 'center',
        textAlign: 'justify',
        fontSize: "12px",
    },
    politicaTitulo: {
        display: "flex",
        justifyContent: 'center',
        flexDirection: 'row',
        alignItems: 'center',
        fontSize: "18px",
        color: "#2196f3",
        /* marginTop: "10px", */
        backgroundColor: "#e3f2fd",
        height: 10+"vh",
    },
    politicaTituloSecundario: {
        display: "flex",
        flexDirection: 'row',
        alignItems: 'center',
        fontSize: "14px",
        color: "#2196f3",
        marginTop: "25px",
        backgroundColor: "#fff",
    },
});

class PoliticaPrivacidad extends React.Component  {
    constructor(props) {
        super(props);
        this.state = {deportes: []};
    }

    render() {

        const  classes  = this.props.classes;
        //const { t } = this.props;
        return (
        <div className={classes.root}>
            <Grid container spacing={0} className={classes.politicaContenedor}>
                
                <Grid item sm={12} className={classes.politicaTitulo}>  
                <b>POLÍTICA DE PRIVACIDAD</b>
                </Grid>

                <Grid item sm={10} className={classes.politicaTituloSecundario}>  
                <b>1. INFORMACIÓN AL USUARIO</b>
                </Grid>
                <Grid item sm={10} className={classes.politicaText}> 
                INGENIOKIDS, como Responsable del Tratamiento, le informa que, según lo dispuesto en el Reglamento (UE) 2016/679, de 27 de abril, (RGPD) y en la L.O. 3/2018, de 5 de diciembre, de protección de datos y garantía de los derechos digitales (LOPDGDD), trataremos su datos tal y como reflejamos en la presente Política de Privacidad.
                <br/>
                <br/>En esta Política de Privacidad describimos cómo recogemos sus datos personales y por qué los recogemos, qué hacemos con ellos, con quién los compartimos, cómo los protegemos y sus opciones en cuanto al tratamiento de sus datos personales.
                <br/>
                <br/>Esta Política se aplica al tratamiento de sus datos personales recogidos por la empresa para la prestación de sus servicios. Si acepta las medidas de esta Política, acepta que tratemos sus datos personales como se define en esta Política.
                </Grid>
                
                <Grid item sm={10} className={classes.politicaTituloSecundario}>  
                <b>2.  CONTACTO</b>
                </Grid>
                <Grid item sm={10} className={classes.politicaText}>
                Denominación social: Maria Carmen Herrero Martínez
                <br/>Nombre comercial: INGENIOKIDS
                <br/>CIF: 44794646F
                <br/> Domicilio: C/Cózar, 8 - 46520 - Puerto Sagunto (Valencia)
                <br/>e-mail: maika.herrero@ingeniokids.com
                </Grid>

                <Grid item sm={10} className={classes.politicaTituloSecundario}>  
                <b>3. PRINCIPIOS CLAVE</b>
                </Grid>
                <Grid item sm={10} className={classes.politicaText}> 
                Siempre hemos estado comprometidos con prestar nuestros servicios con el más alto grado de calidad, lo que incluye tratar sus datos con seguridad y transparencia. Nuestros principios son:
                <br/>
                <br/>1. Legalidad: Solo recopilaremos sus Datos personales para fines específicos, explícitos y legítimos.
                <br/>2. Minimización de datos: Limitamos la recogida de datos de carácter personal a lo que es estrictamente relevante y necesario para los fines para los que se han recopilado.
                <br/>3. Limitación de la Finalidad: Solo recogeremos sus datos personales para los fines declarados y solo según sus deseos.
                <br/>4. Precisión: Mantendremos sus datos personales exactos y actualizados.
                <br/>5. Seguridad de los Datos: Aplicamos las medidas técnicas y organizativas adecuadas y proporcionales a los riesgos para garantizar que sus datos no sufran daños, tales como divulgación o acceso no autorizado, la destrucción accidental o ilícita o su pérdida accidental o alteración y cualquier otra forma de tratamiento ilícito.
                <br/>6. Acceso y Rectificación: Disponemos de medios para que acceda o rectifique sus datos cuando lo considere oportuno.
                <br/>7. Conservación: Conservamos sus datos personales de manera legal y apropiada y solo mientras es necesario para los fines para los que se han recopilado.
                <br/>8. Las transferencias internacionales: cuando se dé el caso de que sus datos vayan a ser transferidos fuera de la UE/EEE se protegerán adecuadamente.
                <br/>9. Terceros: El acceso y transferencia de datos personales a terceros se llevan a cabo de acuerdo con las leyes y reglamentos aplicables y con las garantías contractuales adecuadas.
                <br/>10. Marketing Directo y cookies: Cumplimos con la legislación aplicable en materia de publicidad y cookies.
                </Grid>

                <Grid item sm={10} className={classes.politicaTituloSecundario}>  
                <b>4. RECOGIDA Y TRATAMIENTO DE SUS DATOS PERSONALES</b>
                </Grid> 
                <Grid item sm={10} className={classes.politicaText}>
                 Los tipos de datos que se pueden solicitar y tratar son:
                <br/>- Datos de carácter identificativo.
                <br/>
                <br/>También recogemos de forma automática datos sobre su visita a nuestro sitio web  según se describe en la política de cookies.
                <br/>
                <br/>Siempre que solicitemos sus Datos personales, le informaremos con claridad de qué datos personales recogemos y con qué fin. En general, recogemos y tratamos sus datos personales con el propósito de:
                <br/>- Proporcionar información, servicios, productos, información relevante y novedades en el sector.
                <br/>- Envío de comunicaciones.
                </Grid>


                <Grid item sm={10} className={classes.politicaTituloSecundario}>  
                <b>5. LEGITIMIDAD</b>
                </Grid>  
                <Grid item sm={10} className={classes.politicaText}>
                De acuerdo con la normativa de protección de datos aplicable, sus datos personales podrán tratarse siempre que:
                <br/>1. Nos ha dado su consentimiento a los efectos del tratamiento. Por supuesto podrá retirar su consentimiento en cualquier momento.
                <br/>2. Por requerimiento legal.
                <br/>3. Por exisitr un interés legítimo que no se vea menoscabado por sus derechos de privacidad, como por ejemplo el envío de información comercial bien por suscripción a nuestra newsletter o por su condición de cliente.
                <br/>4. Por se necesaria para la prestación de alguno de nuestros servicios mediante relación contractual entre usted y nosotros.
                </Grid>

                <Grid item sm={10} className={classes.politicaTituloSecundario}>  
                <b> 6. COMUNICACIÓN DE DATOS PERSONALES</b>
                </Grid>  
                <Grid item sm={10} className={classes.politicaText}> 
                Los datos pueden ser comunicados a empresas relacionadas con INGENIOKIDS para la prestación de los diversos servicios en calidad de Encargados del Tratamiento. La empresa no realizará ninguna cesión, salvo por obligación legal.
                </Grid>

                <Grid item sm={10} className={classes.politicaTituloSecundario}>  
                <b> 7. SUS DERECHOS</b>
                </Grid>  
                <Grid item sm={10} className={classes.politicaText}>
                En relación con la recogida y tratamiento de sus datos personales, puede ponerse en contacto con nosotros en cualquier momento para:
                <br/>1. Acceder a sus datos personales y a cualquier otra información indicada en el Artículo 15.1 del RGPD.
                <br/>2. Rectificar sus datos personales que sean inexactos o estén incompletos de acuerdo con el Artículo 16 del RGPD.
                <br/>3. Suprimir sus datos personales de acuerdo con el Artículo 17 del RGPD.
                <br/>4. Limitar el tratamiento de sus datos personales de acuerdo con el Artículo 18 del RGPD.
                <br/>5. Solicitar la portabilidad de sus datos de acuerdo con el Artículo 20 del RGPD.
                <br/>6. Oponerse al tratamiento de sus datos personales de acuerdo con el artículo 21 del RGPD.
                <br/>
                <br/>Si ha otorgado su consentimiento para alguna finalidad concreta, tiene derecho a retirar el consentimiento otorgado en cualquier momento, sin que ello afecte a la licitud del tratamiento basado en el consentimiento previo a su retirada.
                <br/>
                <br/>Puede ejercer estos derechos enviando comunicación, motivada y acreditada, a maika.herrero@ingeniokids.com
                <br/>
                <br/>También tiene derecho a presentar una reclamación ante la Autoridad de control competente <Link target="_blank" href="https://tools.google.com/dlpage/gaoptout?hl=es">(www.aepd.es)</Link> si considera que el tratamiento no se ajusta a la normativa vigente.
                </Grid>

                <Grid item sm={10} className={classes.politicaTituloSecundario}>  
                <b> 8. INFORMACIÓN LEGAL</b>
                </Grid>  
                <Grid item sm={10} className={classes.politicaText}>  
                Los requisitos de esta Política complementan, y no reemplazan, cualquier otro requisito existente bajo la ley de protección de datos aplicable, que será la que prevalezca en cualquier caso.
                <br/>
                <br/>Esta Política está sujeta a revisiones periódicas y la empresa puede modificarla en cualquier momento. Cuando esto ocurra, le avisaremos de cualquier cambio y le pediremos que vuelva a leer la versión más reciente de nuestra Política y que confirme su aceptación.
                <br/>
                <br/>IMPORTANTE: En caso de que existieran diferencias o contradicciones entre las versiones de la plataforma publicadas en otros idiomas, prevalecerá en todo caso la versión española.
                </Grid>
            </Grid>
        </div>
        );
    }

};

export default withTranslation()(withStyles(useStyles)(PoliticaPrivacidad));